import { useMutation } from "@tanstack/react-query";
import { shipmentTruckingGuestService, UpdateTruckingRouteDto } from "../services/shipmentTruckingGuestService";

interface MutationVariables {
  shipmentTruckingId: string;
  payload: UpdateTruckingRouteDto;
}

export const useUpdateTruckingRoute = () => {
  return useMutation<void, Error, MutationVariables>({
    mutationFn: ({ shipmentTruckingId, payload }) => shipmentTruckingGuestService.updateRoute(shipmentTruckingId, payload),
  });
};
